<template>
  <div class="TemplateLogin">
    <section class="TemplateLogin-form">
      <slot />
    </section>

    <section
      class="TemplateLogin-img"
      ref="imageContainer"
      :class="{ 'TemplateLogin-img--is-sponsor': typeMode === 'Sponsor' }"
    >
      <img
        :class="customClassLoginImg"
        :style="isPartnerAndImgStyleExist ? customStyle.loginPage.imgStyle : ''"
        :src="loginImgSrc"
        :srcset="loginImgSrc + ' 800w,' + loginImgSrc + ' 1200w'"
        alt="illustration"
      />
    </section>

    <section class="TemplateLogin-form TemplateLogin-form--sponsor">
      <slot name="partner" />
    </section>
  </div>
</template>

<script>
'use strict'

import illustration from '@/assets/illustration/illustration.png'
import { mapGetters } from 'vuex'

export default {
  name: 'TemplateLogin',
  props: {
    typeMode: { type: String }
  },

  data() {
    return {
      classLoginImg: 'TemplateLogin-img-baseImg'
    }
  },

  computed: {
    ...mapGetters({
      customStyle: 'auth/customStyle'
    }),

    /**
     * @returns {string}
     */
    customClassLoginImg() {
      return this.classLoginImg
    },

    /**
     * @returns {boolean}
     */
    isPartnerAndImgStyleExist() {
      return (
        this.$isPartner() &&
        typeof this.customStyle.loginPage.imgStyle !== 'string'
      )
    },

    loginImgSrc() {
      if (this.$isPartner()) {
        try {
          this.classLoginImg = 'TemplateLogin-img-MBImg'
          return require(`@/assets/shared/organization/${process.env.VUE_APP_SHARED_DIRECTORY}/${this.customStyle.loginPage.image}`)
        } catch {
          this.classLoginImg = 'TemplateLogin-img-baseImg'
          //In case, local dev or partner logo was not found
          return illustration
        }
      } else {
        this.classLoginImg = 'TemplateLogin-img-baseImg'
        return illustration
      }
    }
  },

  methods: {
    initCustomStyle() {
      this.$refs.imageContainer.style.background = `
        linear-gradient(
          ${this.customStyle.loginPage.backgroundRadiant.firstColor},
          ${this.customStyle.loginPage.backgroundRadiant.secondColor},
          ${this.customStyle.loginPage.backgroundRadiant.thirdColor}
        )`
    }
  },

  mounted() {
    if (this.$isPartner()) {
      this.initCustomStyle()
    }
  }
}
</script>
<style lang="scss">
@property --myColor1 {
  syntax: '<color>';
  initial-value: #56bff0;
  inherits: false;
}

@property --myColor2 {
  syntax: '<color>';
  initial-value: #6e98ff;
  inherits: false;
}

@property --myColor3 {
  syntax: '<color>';
  initial-value: #8566ff;
  inherits: false;
}

.TemplateLogin {
  display: flex;
  height: 100%;
  min-height: 100vh;
  position: relative;

  @media (max-width: $x-large) {
    flex-direction: column;
    width: auto;
  }

  &-form {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 40%;
    background-color: white;
    padding-bottom: 86px;

    &--sponsor {
      justify-content: flex-end;
    }

    @media (max-width: $x-large) {
      width: 100%;
    }
  }

  &-img {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    transition: right 0.2s linear, --myColor1 0.5s, --myColor2 0.5s,
      --myColor3 0.2s;

    position: absolute;
    right: 0;
    top: 0;
    z-index: 100;

    --myColor1: #56bff0;
    --myColor2: #6e98ff;
    --myColor3: #8566ff;

    background: linear-gradient(
      var(--myColor1),
      var(--myColor2),
      var(--myColor3)
    );

    width: 60%;
    height: 100%;

    &-baseImg {
      width: 70%;
      height: auto;
      @media (max-width: $large) {
        width: 60%;
      }
      @media (max-width: $x-large) {
        width: 50%;
      }
    }

    &-MBImg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: left center;
    }

    &--is-sponsor {
      right: 45%;

      --myColor1: #6e98ff;
      --myColor2: #8566ff;
      --myColor3: #af61d0;
    }

    @media (max-width: $x-large) {
      width: auto;
      height: 100%;
    }
  }
}
</style>
